import React, { useEffect, useState } from 'react';
import SimpleAnimatedCounter from '../components/SimpleAnimatedCounter';

const Projects = () => {
  const [selectedFilter, setSelectedFilter] = useState('all');
  const [showAllImages, setShowAllImages] = useState(false);
  const [loadedImages, setLoadedImages] = useState(new Set());
  const [loadingImages, setLoadingImages] = useState(new Set());

  useEffect(() => {
    document.title = 'Our Projects - VReco Energy | Renewable Energy Portfolio';
    
    // Initialize scroll animations
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, observerOptions);
    
    const fadeElements = document.querySelectorAll('.fade-in');
    fadeElements.forEach(el => observer.observe(el));

    return () => {
      fadeElements.forEach(el => observer.unobserve(el));
    };
  }, []);

  const projects = [
    {
      id: 1,
      title: "KP Green Energy - Phase 1",
      description: "90 MW wind farm project for CLP India / Apraava Energy",
      category: "wind",
      status: "Completed",
      capacity: "90 MW",
      location: "Gujarat, India",
      client: "CLP India / Apraava Energy",
      logo: "/img/kp_logo.png"
    },
    {
      id: 2,
      title: "KP Green Energy - Phase 2", 
      description: "60 MW wind farm project for CLP India / Apraava Energy",
      category: "wind",
      status: "Completed",
      capacity: "60 MW",
      location: "Gujarat, India",
      client: "CLP India / Apraava Energy",
      logo: "/img/kp_logo.png"
    },
    {
      id: 3,
      title: "KP Green Energy",
      description: "150 MW ongoing wind farm project with KP Energy independently",
      category: "wind",
      status: "Ongoing",
      capacity: "150 MW",
      location: "Gujarat, India",
      client: "NTPC Ltd",
      logo: "/img/kp_logo.png"
    },
    {
      id: 4,
      title: "486 Hybrid Wind Project",
      description: "Working on 72 MW portion of 486 MW total capacity hybrid wind project",
      category: "wind",
      status: "Ongoing",
      capacity: "72 MW (of 486 MW total)",
      location: "Gujarat, India",
      client: "Torrent Power Ltd & Suzlon Ltd",
      partner: "BA Prerna Renewables",
      logo: "/img/ba_prerna_logo.png"
    }
  ];

  const galleryImages = [
    // Default
    { src: "/img/site_pics/land_level.jpg", title: "Land Leveling", category: "foundation" },
    { src: "/img/site_pics/33kv_line.jpg", title: "33 KV Power Line", category: "electrical" },
    { src: "/img/site_pics/wtg_erection3.jpg", title: "WTG Erection Process", category: "construction" },
    { src: "/img/site_pics/wtg_excavation.jpg", title: "Site Excavation", category: "foundation" },
    { src: "/img/site_pics/wtg_foundation_civil.jpg", title: "Foundation Civil Work", category: "foundation" },
    { src: "/img/site_pics/wtg_foundation_civil_7.jpg", title: "Foundation Civil Work", category: "foundation" },
    { src: "/img/site_pics/wtg_stub_assembly_7.jpg", title: "Stub Assembly", category: "construction" },
    { src: "/img/site_pics/electrical_line_5.jpg", title: "Power Distribution", category: "electrical" },
    { src: "/img/site_pics/wtg_area_development.jpg", title: "Area Development", category: "construction" },

    // Foundation Images
    { src: "/img/site_pics/wtg_erection.jpg", title: "WTG Erection", category: "construction" },
    { src: "/img/site_pics/wtg_erection_1.jpg", title: "Wind Turbine Installation", category: "construction" },
    { src: "/img/site_pics/wtg_foundation.jpg", title: "WTG Foundation", category: "foundation" },
    { src: "/img/site_pics/wtg_foundation_9.jpg", title: "Foundation Construction Phase", category: "foundation" },
    { src: "/img/site_pics/wtg_foundation_civil2.jpg", title: "Civil Foundation Work", category: "foundation" },
    { src: "/img/site_pics/wtg_foundation_civil3.jpg", title: "Foundation Construction Phase", category: "foundation" },
    { src: "/img/site_pics/wtg_foudation_civil_4.jpg", title: "Foundation Construction Phase", category: "foundation" },
    { src: "/img/site_pics/wtg_foundation_civil5.jpg", title: "Foundation Construction Phase", category: "foundation" },
    { src: "/img/site_pics/wtg_foundation_civil8.jpg", title: "Foundation Construction Phase", category: "foundation" },
    
    // Excavation Images
    { src: "/img/site_pics/wtg_excavation_1.jpg", title: "Excavation Work", category: "foundation" },
    
    
    // Heavy Equipment Images
    { src: "/img/site_pics/heavy_machine_1.jpg", title: "Heavy Machinery", category: "equipment" },
    { src: "/img/site_pics/Heavy_machinery.jpg", title: "Heavy Equipment", category: "equipment" },
    
    // Assembly Images
    { src: "/img/site_pics/wtg_boom_assembly.jpg", title: "Boom Assembly", category: "construction" },
    { src: "/img/site_pics/wtg_lattice_assembly.jpg", title: "Lattice Assembly", category: "construction" },
    { src: "/img/site_pics/wtg_lattice_assembly_1.jpg", title: "Lattice Assembly Process", category: "construction" },
    
    // Stub Assembly Images
    { src: "/img/site_pics/wtg_stub_assembly.jpg", title: "Stub Assembly", category: "construction" },
    { src: "/img/site_pics/wtg_stub_assembly_3.jpg", title: "Stub Assembly Process", category: "construction" },
    { src: "/img/site_pics/wtg_stub_assembly_5.jpg", title: "Stub Assembly Phase", category: "construction" },

    { src: "/img/site_pics/wtg_stub_assesmbly_7.jpg", title: "Stub Final Assembly", category: "construction" },
    
    // Electrical Line Images
    { src: "/img/site_pics/220_kv_line.jpg", title: "220 KV Electrical Line", category: "electrical" },
    { src: "/img/site_pics/electical_line_2.jpg", title: "Electrical Infrastructure", category: "electrical" },
    { src: "/img/site_pics/electrical_line_3.jpg", title: "Power Line Installation", category: "electrical" },
    { src: "/img/site_pics/electrical_line_4.jpg", title: "Power Line Installation", category: "electrical" },
    
    
    // Site Development Images
    { src: "/img/site_pics/wtg_pathway0.jpg", title: "Access Road", category: "construction" },
    
  ];

  const filterProjects = (category) => {
    setSelectedFilter(category);
  };

  const handleImageLoad = (imageSrc) => {
    setLoadedImages(prev => new Set(prev).add(imageSrc));
    setLoadingImages(prev => {
      const newSet = new Set(prev);
      newSet.delete(imageSrc);
      return newSet;
    });
  };

  const handleImageError = (imageSrc) => {
    console.warn(`Failed to load image: ${imageSrc}`);
    setLoadingImages(prev => {
      const newSet = new Set(prev);
      newSet.delete(imageSrc);
      return newSet;
    });
  };


  const filteredImages = selectedFilter === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === selectedFilter);

  const getInitialDisplayImages = () => {
    if (selectedFilter !== 'all') {
      return filteredImages;
    }
    
    if (showAllImages) {
      // Show all images in their original order
      return galleryImages;
    }
    
    // Show only first 9 default images
    return galleryImages.slice(0, 9);
  };

  const displayedImages = getInitialDisplayImages();

  // Initialize loading state for displayed images
  useEffect(() => {
    const currentDisplayedImages = getInitialDisplayImages();
    const newLoadingImages = new Set();
    currentDisplayedImages.forEach(image => {
      if (!loadedImages.has(image.src)) {
        newLoadingImages.add(image.src);
      }
    });
    setLoadingImages(newLoadingImages);
  }, [selectedFilter, showAllImages]);

  return (
    <div className="projects-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <h1>Our Projects</h1>
          <p>Showcasing our commitment to renewable energy excellence</p>
        </div>
      </section>

      {/* Project Statistics */}
      <section className="content-section">
        <div className="container">
          <h2 className="section-title fade-in">Project Overview</h2>
          <p className="section-subtitle fade-in">Our track record of successful renewable energy implementations</p>
          
          <div className="stats fade-in">
            <div className="stat-item">
              <SimpleAnimatedCounter end={310} suffix="+" />
              <span className="stat-label">MW Completed</span>
            </div>
            <div className="stat-item">
              <SimpleAnimatedCounter end={150} suffix="+" />
              <span className="stat-label">MW Ongoing</span>
            </div>
            <div className="stat-item">
              <SimpleAnimatedCounter end={9} suffix="+" />
              <span className="stat-label">Projects Completed</span>
            </div>
            <div className="stat-item">
              <SimpleAnimatedCounter end={100} suffix="%" />
              <span className="stat-label">Success Rate</span>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Projects */}
      <section className="section">
        <div className="container">
          <h2 className="section-title fade-in">Featured Projects</h2>
          <p className="section-subtitle fade-in">Major renewable energy initiatives driving sustainable development</p>
          
          <div className="projects-grid">
            {projects.map(project => (
              <div key={project.id} className="project-card fade-in">
                <div className="project-image" style={{
                  background: 'white',
                  padding: '2rem',
                  borderRadius: '15px',
                  boxShadow: '0 5px 15px rgba(0, 0, 0, 0.1)',
                  transition: 'transform 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '150px',
                  height: '150px',
                  margin: '0 auto'
                }}>
                  <img 
                    src={project.logo} 
                    alt={`${project.title} Logo`}
                    style={{ 
                      width: '100px', 
                      height: '100px', 
                      objectFit: 'contain'
                    }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      const fallback = e.target.nextElementSibling;
                      if (fallback) fallback.style.display = 'block';
                    }}
                  />
                  <span 
                    style={{ 
                      fontSize: '3rem', 
                      display: 'none',
                      color: '#1565C0'
                    }}
                  >
                    ⚡
                  </span>
                </div>
                <div className="project-content">
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                  <div style={{ marginTop: '1rem' }}>
                    <p><strong>Status:</strong> {project.status}</p>
                    <p><strong>Capacity:</strong> {project.capacity}</p>
                    <p><strong>Location:</strong> {project.location}</p>
                    <p><strong>Client:</strong> {project.client}</p>
                    {project.partner && <p><strong>Partner:</strong> {project.partner}</p>}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Project Gallery */}
      <section className="content-section">
        <div className="container">
          <h2 className="section-title fade-in">Project Gallery</h2>
          <p className="section-subtitle fade-in">Visual documentation of our renewable energy projects</p>
          
          {/* Gallery Filters */}
          <div className="gallery-filters fade-in">
            <button 
              className={`filter-btn ${selectedFilter === 'all' ? 'active' : ''}`}
              onClick={() => filterProjects('all')}
            >
              All Images
            </button>
            <button 
              className={`filter-btn ${selectedFilter === 'construction' ? 'active' : ''}`}
              onClick={() => filterProjects('construction')}
            >
              Construction
            </button>
            <button 
              className={`filter-btn ${selectedFilter === 'foundation' ? 'active' : ''}`}
              onClick={() => filterProjects('foundation')}
            >
              Foundation
            </button>
            <button 
              className={`filter-btn ${selectedFilter === 'equipment' ? 'active' : ''}`}
              onClick={() => filterProjects('equipment')}
            >
              Equipment
            </button>
            <button 
              className={`filter-btn ${selectedFilter === 'electrical' ? 'active' : ''}`}
              onClick={() => filterProjects('electrical')}
            >
              Electrical
            </button>
          </div>
          
          {/* Gallery Grid */}
          <div className="gallery-grid fade-in">
            {displayedImages.map((image, index) => (
              <div key={index} className="gallery-item" data-category={image.category} style={{ display: 'block' }}>
                {/* Loading Animation */}
                {loadingImages.has(image.src) && (
                  <div className="image-loading-overlay">
                    <div className="loading-spinner">
                      <div className="spinner-ring"></div>
                      <div className="loading-text">Loading...</div>
                    </div>
                  </div>
                )}
                
                <img 
                  src={image.src} 
                  alt={image.title}
                  loading="lazy"
                  decoding="async"
                  className={`progressive-img ${loadedImages.has(image.src) ? 'loaded' : 'loading'}`}
                  style={{
                    opacity: loadedImages.has(image.src) ? 1 : 0,
                    transition: 'opacity 0.3s ease'
                  }}
                  onLoad={() => handleImageLoad(image.src)}
                  onError={(e) => {
                    handleImageError(image.src);
                    const galleryItem = e.target.closest('.gallery-item');
                    if (galleryItem) galleryItem.style.display = 'none';
                  }}
                />
                
                <div className="gallery-overlay">
                  <h4>{image.title}</h4>
                  <p>VReco Energy Project</p>
                </div>
              </div>
            ))}
          </div>
          
          {/* View More Button */}
          {filteredImages.length > 9 && (
            <div style={{ textAlign: 'center', marginTop: '2rem' }}>
              <button 
                className="cta-button"
                onClick={() => {
                  const newState = !showAllImages;
                  setShowAllImages(newState);
                  
                  // If switching to "View Less", scroll to gallery section
                  if (!newState) {
                    setTimeout(() => {
                      const galleryElement = document.querySelector('.gallery-grid');
                      if (galleryElement) {
                        const galleryTop = galleryElement.offsetTop - 100; // 100px offset for navbar
                        window.scrollTo({
                          top: galleryTop,
                          behavior: 'smooth'
                        });
                      }
                    }, 100); // Small delay to ensure state update
                  }
                }}
              >
                {showAllImages ? 'View Less Images' : 'View More Images'}
              </button>
            </div>
          )}
        </div>
      </section>

      {/* Project Capabilities */}
      <section className="section why-choose">
        <div className="container">
          <h2 className="section-title fade-in" style={{ color: 'white' }}>Our Project Capabilities</h2>
          <p className="section-subtitle fade-in" style={{ color: 'rgba(255,255,255,0.9)' }}>Comprehensive expertise across all phases of renewable energy projects</p>
          
          <div className="features-grid">
            <div className="feature-item fade-in">
              <div className="feature-icon">🏗️</div>
              <h3>Construction Excellence</h3>
              <p>Advanced construction techniques and experienced teams ensure quality execution of complex renewable energy projects.</p>
            </div>
            
            <div className="feature-item fade-in">
              <div className="feature-icon">🔧</div>
              <h3>Technical Expertise</h3>
              <p>Deep technical knowledge in wind turbine installation, electrical systems, and renewable energy infrastructure.</p>
            </div>
            
            <div className="feature-item fade-in">
              <div className="feature-icon">📊</div>
              <h3>Project Management</h3>
              <p>Proven project management methodologies ensuring on-time delivery and budget compliance for all projects.</p>
            </div>
            
            <div className="feature-item fade-in">
              <div className="feature-icon">🌍</div>
              <h3>Environmental Focus</h3>
              <p>All projects are executed with strong environmental consciousness and sustainable development principles.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Projects;